import { useStaticQuery, graphql } from 'gatsby'

export function useDataSecondScreenByEn() {
    const data = useStaticQuery(graphql`
        {
            sectionTitle: datoCmsRenshinPageMain(title: { eq: "Slide 2: Title" }, locale: { eq: "en" }) {
                value
            }

            title: datoCmsRenshinPageMain(title: { eq: "Slide 2: Text" }, locale: { eq: "en" }) {
                value
            }
        }
    `)

    return data
}
